const rankings = [
  { rank: 1, title: '繁花', type: '电视剧', heat: '987万', trend: 'up', desc: '王家卫首部电视剧，沪上风云故事' },
  { rank: 2, title: '流浪地球3', type: '电影', heat: '856万', trend: 'up', desc: '史诗科幻巨制，4K独家上线' },
  { rank: 3, title: '庆余年2', type: '电视剧', heat: '743万', trend: 'up', desc: '播放量破5亿的权谋大剧' },
  { rank: 4, title: '乘风破浪的姐姐', type: '综艺', heat: '692万', trend: 'new', desc: '全新赛季，破浪而来' },
  { rank: 5, title: '漫长的季节', type: '电视剧', heat: '581万', trend: 'up', desc: '年度口碑悬疑神作' },
  { rank: 6, title: '鬼灭之刃 柱训练篇', type: '动漫', heat: '524万', trend: 'new', desc: '热血番剧最新季火爆上线' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">热播榜单</h2>
          <p className="text-sm text-foreground-500">实时热度排行 · 大家都在看</p>
        </div>

        <div className="rounded-2xl bg-background-100 border border-background-200/70 overflow-hidden">
          {rankings.map((item, idx) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 p-4 md:p-5 cursor-pointer hover:bg-background-50 transition-colors ${
                idx < rankings.length - 1 ? 'border-b border-background-200/70' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 md:w-9 md:h-9 rounded-lg flex items-center justify-center text-sm font-bold ${
                item.rank === 1
                  ? 'bg-primary-500 text-background-50'
                  : item.rank === 2
                  ? 'bg-accent-500 text-background-50'
                  : item.rank === 3
                  ? 'bg-secondary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-950">{item.title}</h3>
                  <span className="flex-shrink-0 px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                    {item.type}
                  </span>
                  {item.trend === 'new' && (
                    <span className="flex-shrink-0 px-2 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                      NEW
                    </span>
                  )}
                </div>
                <p className="text-xs text-foreground-500 mt-0.5">{item.desc}</p>
              </div>

              <div className="flex-shrink-0 flex items-center gap-1.5">
                <span className="text-xs text-foreground-400">{item.heat}</span>
                <i className={`text-sm ${
                  item.trend === 'up' ? 'ri-arrow-up-line text-primary-500' : 'ri-sparkling-line text-accent-500'
                }`}></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}